import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getAlloffice } from "../../actions/warehouseAction";
import Rendertable from "./Rendertable";

const WarehouseList = ({ getAlloffice, List, updatelist, setUpdatelist }) => {
  useEffect(() => {
    getAlloffice();
    setUpdatelist(true);
  }, [getAlloffice, updatelist, setUpdatelist]);

  return (
    <>
      {
        <Rendertable
          List={List}
          updatelist={updatelist}
          setUpdatelist={setUpdatelist}
        />
      }
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    List: state.warehouse.outletlist,
  };
};

export default connect(mapStateToProps, {
  getAlloffice,
})(WarehouseList);
